/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_WinnerInputs */



/**
* | output |
* | --- |
* | "Winner" |
*
* @param {Tournament_WinnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_winner = /** @type {((inputs?: Tournament_WinnerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_WinnerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vainqueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ganador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vencedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vincitore")
	return /** @type {LocalizedString} */ ("Winner")
});